import courierPlanTemplate from './courier-plan-template'
import trafficPlanTemplate from './traffic-plan-template'


export default {
    name: 'TimeSheet',
    path: 'time-sheet',
    meta: {
        label: 'timeSheet',
        auth: 'timeSheet'
    },
    component: {
        name: 'TimeSheet',
        render(c) {
            return c('router-view')
        }
    },
    children: [trafficPlanTemplate, courierPlanTemplate]
}